module.exports = __webpack_public_path__ + "image-9d7bca67eedd.png";